export default __webpack_public_path__ + "static/media/Icons_ElectricOff_Grey Icon.da6d0dc1.svg";